import React, { useEffect, useRef, useState } from 'react';
import { IAlertsFilters } from '../types';
import IAlert from '../types/IAlert';
import * as screeningService from '../services/screening.service';
import AlertsGrid from '../components/alerts/AlertsGrid';
import * as notify from 'src/services/notification.service';
import * as paginationService from 'src/services/pagination.service';

const AlertsPage: React.FC = () => {
  const fileUploadProgressTracker = useRef<(progress: number) => void>();
  const [pristine, setPristine] = useState<boolean>(true);
  const [alerts, setAlerts] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [nextPage, setNextPage] = useState<string>('');
  const [pageStates, setPageStates] = useState<string[]>(['']);
  const [currentRecordsPerPage, setCurrentRecordsPerPage] = useState<number>(10);
  const [totalRecordsAvailable, setTotalRecordsAvailable] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<IAlertsFilters>({
    database: '',
    category: '',
    subCategory: '',
    updatedDate: '',
  });
  const [filtersData, setFiltersData] = useState({
    databases: [],
    categories: [],
    subcategories: [],
  });
  const [sortBy, setSortBy] = useState<string>('match|desc');
  const [searchParameters, setSearchParameters] = useState<{ formData: FormData }>();
  let searchParamsChanged = useRef<any>();
  let currentPageRef = useRef<number>(1);
  let alertsRef = useRef<IAlert[]>([]);
  const [isErrorLoadingAlerts, setIsErrorLoadingAlerts] = useState<boolean>(false);

  currentPageRef.current = currentPage;
  alertsRef.current = alerts;

  const fetchAlerts = (firstPage = false, showLoader = true) => {
    showLoader && setIsLoading(true);
    screeningService
      .fetchAlerts({ ...filters }, firstPage ? '' : nextPage, currentRecordsPerPage, sortBy)
      // @ts-ignore
      .then((response) => {
        const data = response.data.data;
        setAlerts(data.results);
        setTotalPages(data.paging.totalPages);
        setPageStates([...pageStates, data.paging.nextPage]);
        setNextPage(data.paging.nextPage || '');
        setTotalRecordsAvailable(data.paging.totalRecordsAvailable);
        setIsLoading(false);
        setFiltersData(data.filtersData);
      })
      .catch((err: any) => {
        console.log({ err });
        if (!err.response.handled) {
          if (err?.response?.data?.error?.message) notify.error(err.response.data.error.message);
        }
        setIsErrorLoadingAlerts(true);
        setAlerts([]);
        setTotalPages(0);
        setNextPage('');
        setTotalRecordsAvailable(0);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // todo
  const searchParametersChanged = async (params: {
    formData: FormData;
    fileUploadProgressHandler: (progress: number) => void;
  }) => {
    setPristine(false);
    searchParamsChanged.current = true;
    fileUploadProgressTracker.current = params.fileUploadProgressHandler;
    setSearchParameters({ formData: params.formData });
  };
  const currentPageChanged = async (pageNumber: number) => {
    const { nextPage, computedPageStates } = paginationService.computeNextPage(
      currentPage,
      pageNumber,
      pageStates,
    );
    setNextPage(nextPage);
    setPageStates(computedPageStates);
    setCurrentPage(pageNumber);
  };
  const setRecordsPerPage = async (recordsCount: number) => {
    removePages();
    setCurrentRecordsPerPage(recordsCount);
  };
  const filtersChanged = async (filters: IAlertsFilters) => {
    removePages();
    setFilters(filters);
  };
  const sortingChanged = async () => {};

  const removePages = () => {
    setPageStates(['']);
    setNextPage('');
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchAlerts();
  }, [filters, currentPage, currentRecordsPerPage, sortBy]);

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card-title">
            <h4>ALERTS</h4>
          </div>
        </div>
        <div className="col-lg-12">
          {!isErrorLoadingAlerts ? (
            <div className="card" data-testid={isLoading ? 'loading' : 'loaded'}>
              <AlertsGrid
                results={alerts}
                fetchPage={currentPageChanged}
                currentPage={currentPage}
                currentRecordsPerPage={currentRecordsPerPage}
                setRecordsPerPage={setRecordsPerPage}
                totalRecordsAvailable={totalRecordsAvailable}
                totalPages={totalPages}
                filtersData={filtersData}
                filtersChanged={filtersChanged}
                isScreening={isLoading}
                sortingChanged={sortingChanged}
                sortBy={sortBy}
              />
            </div>
          ) : (
            <div className="card">Something went wrong</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertsPage;
